import React, { KeyboardEvent } from "react";
import { Tabs, Tab } from "./Tabs";
import { Content } from "./Content";
import { Header } from "../../Header";
import cname from "../style.module.scss";
import { Button } from "@learningblocks/shared-components";
import { isActivationKey } from "@learningblocks/shared-components";
import { Modal } from "@learningblocks/shared-components/lib/Modal";
import { INFO_TABS } from "../Spectrophotometer.utils";
import "./style.scss";

/**
 * Props for the SpectrophotometerInfoModal component
 */
interface SpectrophotometerInfoModalProps {
  /**
   * Whether the modal window is open
   */
  isOpen: boolean;
  /**
   * Function to call when closing the modal window
   */
  onClose: () => void;
  /**
   * Whether the notebook is collapsed
   */
  notebookCollapsed: boolean;
  /**
   * size of  header
   */
  size: "sm" | "md" | "lg";
}

/**
 * SpectrophotometerInfoModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function SpectrophotometerInfoModal(
  props: SpectrophotometerInfoModalProps
) {
  const [tabs, updateTabs] = React.useState(INFO_TABS);

  const setTabCurrent = (label: string) => {
    const mapTabs = (tab: { label: string; current: boolean }) => {
      if (tab.label === label) return { ...tab, current: true };
      else return { ...tab, current: false };
    };
    updateTabs((tabs) => tabs.map(mapTabs));
  };

  const renderTab = (tab: { label: string; current: boolean }) => (
    <Tab
      key={tab.label}
      label={tab.label}
      current={tab.current}
      onClick={setTabCurrent}
    />
  );

  const currentType = React.useMemo(
    () => tabs.find((tab) => tab.current)?.label || "",
    [tabs]
  );
  const onEnter = (e: React.KeyboardEvent) => {
    if (isActivationKey(e)) {
      e.preventDefault();
      props.onClose();
    }
  };

  return (
    <Modal
      isOpen={props.isOpen}
      className={`${cname.infoModal} spectrophotometer_infoModal`}
      closeButton={true}
      notebookExpanded={!props.notebookCollapsed}
      close={props.onClose}
    >
      <Header
        className={cname.header}
        label="SPECTROPHOTOMETER INFO"
        size={props.size}
      />
      <div className={cname.section}>
        <Tabs>{tabs.map(renderTab)}</Tabs>
        <Content type={currentType} />
      </div>
      <div className={cname.footer}>
        <Button
          tabIndex={0}
          type="primary"
          onClick={props.onClose}
          ariaLabel="Done"
          onKeyDown={onEnter}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
}

SpectrophotometerInfoModal.defaultProps = {
  isOpen: false,
  size: "lg",
};
